var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    fill: "none",
    d: "M23.28 5.05c-.8.35-1.64.59-2.52.7.91-.54 1.62-1.4 1.95-2.42-.86.51-1.82.88-2.84 1.08-.82-.88-1.99-1.43-3.28-1.43-2.48 0-4.49 2.01-4.49 4.49 0 .35.04.7.09 1.04-3.74-.19-7.06-1.98-9.28-4.7-.39.67-.62 1.45-.62 2.29 0 1.57.8 2.96 2.01 3.78-.74-.02-1.44-.23-2.05-.58v.06c0 2.19 1.56 4.01 3.62 4.42-.38.1-.78.15-1.19.15-.29 0-.57-.03-.85-.08.57 1.78 2.23 3.08 4.2 3.12-1.54 1.2-3.47 1.92-5.58 1.92-.36 0-.72-.02-1.08-.06 1.99 1.28 4.36 2.03 6.9 2.03 8.28 0 12.79-6.87 12.79-12.8 0-.2-.01-.4-.02-.6.88-.64 1.65-1.45 2.26-2.37z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon3);
export default __webpack_public_path__ + "static/media/nav-icon3.72bc02c9b702c6e4cfac4c159b9ae684.svg";
export { ForwardRef as ReactComponent };